import { Outlet } from "react-router";
import SidebarMenu from "./components/SidebarMenu";
import { useSidebar } from "./contexts/SidebarContext";
import { RedirectToLogin } from "./components/auth/RedirectToLogin.tsx";

export default function Layout() {
  const { isSidebarVisible } = useSidebar();

  return (
    <div
      className={`layout-container ${
        !isSidebarVisible ? `layout-static-inactive` : "layout-static"
      }`}
    >
      <main className="layout-content-wrapper">
        <RedirectToLogin />
        <SidebarMenu />
        <Outlet />
      </main>
    </div>
  );
}
